export const roles = {
  ADVISOR: "advisor",
  SUPERVISOR: "supervisor",
  ADMIN: "admin",
  SUPER_ADMIN: "super_admin",
  ENTREPRENEUR: "entrepreneur",
  ADVISOR_LEVEL1: "advisor_level1",
  ADVISOR_LEVEL2: "advisor_level2",
};

export const notificationTypes = {
  NEW_TICKETS: "new_tickets",
  ASSIGN_TICKETS: "assign_tickets",
  ASSIGN_ORDERS: "assign_orders",
  START_EVENTS: "start_events",
};

export const rules = {
  REQUIRED: (v) => !!v || "Campo requerido",
  EMAIL: (v) =>
    !v ||
    (!!v &&
      // eslint-disable-next-line
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        v,
      )) ||
    "Correo electrónico no válido",
  DNI: (v) => /^(\d){8}$/.test(v) || "DNI inválido",
  ONLY_DIGITS: (v) => (!!v && /^\d(\d)*$/.test(v)) || "Solo se permiten dígitos",
  NUMBER: (v) => /^\d(\d)*$/.test(v) || "Cantidad no válida",
  ALPHANUMERIC: (v) => /^[\p{L}0-9 ]+$/u.test(v) || "Carácter no válido",
  STRING_LOWERCASE: (v) => /^[a-z]([a-z])*$/.test(v) || "Sólo letras mínusculas",
  GREATER_THAN_ZERO: (v) => v > 0 || "Debe ser mayor a cero",
  DECIMAL: (v) =>
    !v || (!!v && /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/.test(v)) || "Cantidad no válido",
  CURRENCY: (v) => /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/.test(v) || "Monto no válido", // Nueva regla para URL seguras
  SECURE_URL: (v) =>
    (/^https:\/\/[^\s$.?#].[^\s]*$/.test(v) && /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/.test(v)) ||
    "La URL debe ser válida y comenzar con https",
};

export const ticketStates = {
  NUEVO: "nuevo",
  ORDEN_CREADA: "orden-creada",
  DESESTIMADO: "desestimado",
  INTERESADO: "interesado",
};

export const orderStates = {
  EN_ESPERA: "en-espera",
  TERMINADO: "terminado",
};

export const activityTypes = {
  COMMENT: 0,
  CALL: 1,
  COMMENT_BY_AGENT: 2,
  CONTACT: 3,
  EVENT: 4,
  WHATSAPP: 5,
};

export const integrations = {
  WHATSAPP: "whatsapp",
  SENDGRID: "sendgrid",
  ZOOM_WEBINARS: "zoom_webinars",
  FB_CATALOG: "fb_catalog",
};

export const apolocrmDomain = "wegrou.app";

export const automationTopics = {
  NEW_TICKET: "new_ticket",
  NEW_ORDER: "new_order",
};

export const automationTypes = {
  WHATSAPP_REPLY: "whatsapp_reply",
  WHATSAPP_PERIODIC_MESSAGE: "whatsapp_periodic_messages",
  BOT_WHATSAPP_NOTIFICATION: "bot_whatsapp_notification",
};

export const orderPaymentStates = {
  PENDING: "pago-pendiente",
  PROCESSING: "procesando-pago",
  DECLINED: "pago-rechazado",
  COMPLETED: "pago-completado",
  CANCELED: "pago-anulado",
};

export const orderPaymentMethods = {
  DEBITO_CREDITO: "DEB_CRED",
  TRANSFERENCIA: "TRANSFER",
  YAPE: "YAPE",
  UPON_DELIVERY: "UPON_DELIVERY",
  CASH: "CASH",
};

export const orderDeliveryStates = {
  PENDING: "pendiente-de-entrega",
  SENDING: "enviando-pedido",
  DELIVERED: "pedido-entregado",
  NOT_RECEIVED: "pedido-no-recibido",
};

export const orderDeliveryMethods = {
  STORE: "store",
  ADDRESS: "address",
};

export const cashRegisterStates = {
  OPEN: "open",
  CLOSED: "closed",
  INACTIVE: "inactive",
  CLOSING: "closing",
};

export const stockLogTypes = {
  TRANSFER_WAREHOUSE: "transfer_warehouse",
  PURCHASE: "purchase",
  DECREASE: "descrease",
  SALE: "sale",
  SALE_CANCELED: "sale_canceled",
};
